export default "__VITE_ASSET__1abb4e4e__"